import api from './api';

export const getChemicals = async (params = {}) => {
  try {
    const response = await api.get('/chemicals', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching chemicals:', error);
    throw error;
  }
};

export const createChemical = async (data) => {
  try {
    const response = await api.post('/chemicals', data);
    return response.data;
  } catch (error) {
    console.error('Error creating chemical:', error);
    throw error;
  }
};

export const updateChemical = async (id, data) => {
  try {
    const response = await api.put(`/chemicals/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating chemical:', error);
    throw error;
  }
};

export const uploadChemicalSds = async (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/chemicals/${id}/sds`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const downloadChemicalSds = async (id) => {
  const response = await api.get(`/chemicals/${id}/sds/download`, { responseType: 'blob' });
  return response;
};

export const deleteChemicalSds = async (id) => {
  const response = await api.delete(`/chemicals/${id}/sds`);
  return response.data;
};

export const fetchChemicalSdsFromSupplier = async (id) => {
  const response = await api.post(`/chemicals/${id}/sds/fetch-from-supplier`);
  return response.data;
};

export const exportSdsBinder = async () => {
  const response = await api.get('/chemicals/sds/binder', { responseType: 'blob' });
  return response;
};

export const restoreChemical = async (id) => {
  const response = await api.post(`/chemicals/${id}/restore`);
  return response.data;
};

export const deleteChemical = async (id, retiredOn) => {
  try {
    const response = await api.delete(`/chemicals/${id}`, {
      params: retiredOn ? { retired_on: retiredOn } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting chemical:', error);
    throw error;
  }
};

export const getChemicalChanges = async (chemicalId) => {
  try {
    const response = await api.get(`/chemicals/${chemicalId}/changes`);
    return response.data;
  } catch (error) {
    console.error('Error fetching chemical changes:', error);
    throw error;
  }
};

export const createChemicalChange = async (chemicalId, data) => {
  try {
    const response = await api.post(`/chemicals/${chemicalId}/changes`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating chemical change:', error);
    throw error;
  }
};

export const getAllChemicalChanges = async (params = {}) => {
  try {
    const response = await api.get('/chemicals/changes', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching all chemical changes:', error);
    throw error;
  }
};

export const updateChemicalChange = async (changeId, data) => {
  try {
    const response = await api.put(`/chemicals/changes/${changeId}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating chemical change:', error);
    throw error;
  }
};

export const deleteChemicalChange = async (changeId) => {
  try {
    const response = await api.delete(`/chemicals/changes/${changeId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting chemical change:', error);
    throw error;
  }
};

export const reorderChemicals = async (location, order) => {
  try {
    const response = await api.post('/chemicals/reorder', { location, order });
    return response.data;
  } catch (error) {
    console.error('Error reordering chemicals:', error);
    throw error;
  }
};

export const fetchPrice = async (url) => {
  try {
    const response = await api.get('/chemicals/fetch-price', { params: { url } });
    return response.data;
  } catch (error) {
    console.error('Error fetching price:', error);
    throw error;
  }
};

export const refreshAllPrices = async () => {
  try {
    const response = await api.post('/chemicals/refresh-prices');
    return response.data;
  } catch (error) {
    console.error('Error refreshing prices:', error);
    throw error;
  }
};

export const getChemicalDashboard = async () => {
  try {
    const response = await api.get('/chemicals/dashboard');
    return response.data;
  } catch (error) {
    console.error('Error fetching chemical dashboard:', error);
    throw error;
  }
};
